import axios from "axios";

import { fullAPIURL } from "../utils/requests";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";
import {
  PeopleType,
  MemberRecordType,
  LeadRecordType,
  StaffRecordType,
  LeadStatusType,
  ExportPeopleFilterType,
} from "../pages/People/types";

const profileAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/profile`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

profileAxios.interceptors.request.use(requestAccessTokenInterceptor);
profileAxios.interceptors.request.use(refreshAccessTokenInterceptor);
profileAxios.interceptors.response.use(responseStatusInterceptor);

export type Profile = {
  clientUserUuid: string;
  userUuid: string;
  firstName: string;
  lastName: string;
  memberSince: string;
  dob: string;
  primaryImage: string;
};

export type BirthdayProfile = Profile & {
  birthdayDate: string;
};

export type AnniversaryProfile = Profile & {
  anniversaryDate: string;
};

export interface GetProfilesParams {
  from?: string;
  to?: string;
}

export type GetBirthdaysResponse = {
  data: BirthdayProfile[];
};

export type GetAnniversariesResponse = {
  data: AnniversaryProfile[];
};

export async function getBirthdays(params?: GetProfilesParams) {
  const url = `/birthdays`;
  const response = await profileAxios.get<GetBirthdaysResponse>(url, {
    params,
  });
  return response.data;
}

export async function getAnniversaries(params?: GetProfilesParams) {
  const url = `/anniversaries`;
  const response = await profileAxios.get<GetAnniversariesResponse>(url, {
    params,
  });
  return response.data;
}

export async function getPeopleRecords(peopleType: PeopleType) {
  const response = await profileAxios.get<
    MemberRecordType[] | LeadRecordType[] | StaffRecordType[]
  >(`/people?peopleType=${peopleType}`);
  return response.data;
}

export async function updateLeadStatus(
  userUuid: string,
  leadStatus: LeadStatusType,
) {
  const response = await profileAxios.post(`/lead/status`, {
    userUuid,
    leadStatus,
  });
  return response.data;
}

export async function exportPeopleList(
  peopleType: PeopleType,
  userUuids?: string[],
  filters?: ExportPeopleFilterType,
) {
  const response = await profileAxios.get(`/download`, {
    params: {
      peopleType,
      ...(userUuids && { userUuids: JSON.stringify(userUuids) }),
      ...(filters && { filters: JSON.stringify(filters) }),
    },
  });
  return response.data;
}
